module.exports = __webpack_public_path__ + "static/img/gr.ee6016f9.png";